export const IS_TRANSPORTER_EDIT = 'is_transporter_edit';
export const RESET_TRANSPORTER_PROFILE = 'reset_transporter_profile';
export const GET_TRANSPORTERS = 'get_transporters';
export const GET_TRANSPORTER_PROFILE = 'get_transporter_profile';
export const EDIT_TRANSPORTER_PROFILE = 'edit_transporter_profile';
export const RESET_EDIT_TRANSPORTER_PROFILE = 'reset_edit_transporter_profile';
export const IMPORT_TRANSPORTER = 'import_transporter';
export const DELETE_TRANSPORTER_PROFILE = 'delete_transporter_profile';
export const SET_TRANSPORTER_INFO = 'set_transporter_info';
export const RESET_TRANSPORTERS = 'reset_transporters';
